export const paginateArray = (items, page, per_page) => {
    page = page || 1;
    per_page = per_page || 1;
    const offset = (page - 1) * per_page;
    
    const paginatedItems = items.slice(offset).slice(0, per_page);
    const total_pages = Math.ceil(items.length / per_page);

    return {
        page: page,
        per_page: per_page,
        pre_page: page - 1 ? page - 1 : null,
        next_page: (total_pages > page) ? page + 1 : null,
        total: items.length,
        total_pages: total_pages,
        data: paginatedItems
    };
}

const getNumberOfPagesForCols = (number) => {
    let num;
    for (let i = 20; i >= 1; i--) {
        if(Number.isInteger(number/i)) {
            num = i;
            break;
        }
    }
    return num;
}

export const paginateMatrix = (data, rowPage, colPage, itemsPerPage = 100) => {
    const rowsPerPage = data.length > itemsPerPage ? itemsPerPage : data.length;
    const rowsObj = paginateArray(data, rowPage, rowsPerPage);

    const colsNumbers = rowsObj.data.map(row => row.length);
    const colsNumbersEqual = colsNumbers.every( (val, i, arr) => val === arr[0] );

    if (!colsNumbersEqual) {
        return {
            data: data,
            rowsPage: 1,
            rowsPages: 1,
            colsPage: 1,
            colsPages: 1
        }
    } else {
        const firstRow = data.length !== 0 ? data[0] : [];
        const colsPerPage = getNumberOfPagesForCols(firstRow.length);
        const colsObj = paginateArray(firstRow, colPage, colsPerPage);

        const rowAndCols = rowsObj.data.map(colsSubArr => {
            const colsSubArrPerPage = getNumberOfPagesForCols(colsSubArr.length);
            return paginateArray(colsSubArr, colPage, colsSubArrPerPage).data
        });

        return {
            data: rowAndCols,
            rowsPage: rowsObj.page,
            rowsPages: rowsObj.total_pages,
            colsPage: colsObj.page,
            colsPages: colsObj.total_pages
        }
    }
};